<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col md="6">
                    <ValidationProvider name="class_average" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('class_average')">
                            <b-form-input type="number"
                                          :min="0"
                                          :max="100"
                                          v-model="form.class_average">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="score" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('score')">
                            <b-form-input type="number"
                                          :min="0"
                                          :max="100"
                                          v-model="form.score">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="letter_grade" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('letter_grade')">
                            <grade-selectbox :grading-system-id-required="false"
                                             value-type="grade"
                                             v-model="form.letter_grade" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2">
                {{ $t('save').toLocaleUpperCase('tr-TR') }}
            </b-button>
        </div>
    </div>
</template>

<script>
//Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
//Service
import RelativeGradeService from "@/services/RelativeGradeService";
import GradeSelectbox from "@/components/interactive-fields/GradeSelectbox.vue";

export default {
    components: {
        GradeSelectbox,
        ValidationProvider, ValidationObserver,
    },
    data() {
        return {
            formLoading: false,
            form: {
                class_average: null,
                score: null,
                letter_grade: null,
            }
        }
    },
    methods: {
        async createForm() {
            const isValid = await this.$refs.formModalValidate.validate()
            if (isValid) {
                this.formLoading = true;
                RelativeGradeService.store(this.form)
                    .then((response) => {
                        this.$toast.success(this.$t("api." + response.data.message));
                        this.$emit("createFormSuccess")
                    })
                    .catch((error) => {
                        this.showErrors(error, this.$refs.formModalValidate)
                    }).finally(() => {
                    this.formLoading = false;
                });
            }
        }
    }
}
</script>
